import React from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";

// Shown only after a decline. Most declines we see are the card's bank refusing
// the billing address entered on Telr (e.g. a foreign address on a local card),
// and a different card usually goes through at once.
export default function CardDeclinedTip({ clubName, sx }) {
  return (
    <Box
      sx={{
        mb: 3,
        width: "100%",
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
        p: 1.5,
        borderRadius: 1.5,
        bgcolor: (theme) => alpha(theme.palette.warning.main, 0.12),
        color: "warning.dark",
        textAlign: "left",
        ...sx
      }}
    >
      <CreditCardRoundedIcon fontSize="small" sx={{ mt: "1px" }} />
      <Box>
        <Typography variant="body2" fontWeight={600}>
          Card not going through?
        </Typography>
        <Typography variant="caption" sx={{ display: "block", mt: 0.25 }}>
          Try another card and use your local billing address, or contact {clubName || "the club"} for help.
        </Typography>
      </Box>
    </Box>
  );
}
